import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Configuracao } from '../../../core/models/configuracoes/configuracao';
import { Cliente } from '../../../core/models/clientes/cliente';
import { PrazoMedio } from '../../../core/models/prazos-medio/prazo-medio';
import { PrazoMedioDesconto } from '../../../core/models/prazos-medio/prazo-medio-desconto';
import { PrazoPagamento } from '../../../core/models/prazos-pagamento/prazo-pagamento';

/** Seleção do prazo na etapa Itens e consulta dos saldos. */
@Component({
  selector: 'app-pedido-itens-passo1-toolbar',
  standalone: false,
  templateUrl: './pedido-itens-passo1-toolbar.component.html',
  styleUrls: ['./pedido-itens-passo1-toolbar.component.scss']
})
export class PedidoItensPasso1ToolbarComponent {

  @Input() configuracao: Configuracao = null;
  @Input() pedidoAprovarExterno = false;
  @Input() calculando = false;
  @Input() prazosPagamentoIniciais: PrazoPagamento[] = [];
  @Input() prazosPagamentoEspeciais: PrazoPagamento[] = [];
  @Output() prazoAlterado = new EventEmitter<string>();
  @Input() prazoPagamentoSelecionado: PrazoPagamento = null;
  @Input() clienteSelecionado: Cliente = null;
  @Input() prazoPagamentoInvalido = false;
  @Input() prazoMedio: PrazoMedio = null;
  @Input() prazoMedioDesconto: PrazoMedioDesconto = null;

  @Input() contaCorrenteSaldoDisponivel = 0;
  @Input() saldoGeradoValorFinal = 0;

  get exibirPrazoPagamento(): boolean {
    return this.configuracao != null
      && !this.configuracao.prazo_pagamento_antes_itenspedido
      && this.configuracao.utiliza_fator_financeiro;
  }

}
